import moment from 'moment';
import {
    AddFeedback,
    DeleteSettingData,
    QueryCompanyCode,
    QueryFeedback,
    QueryFeedbackInfo,
    QueryQuickMenu,
    QueryServeDate,
    QuerySettingData,
    QueryTanent,
    QueryUsage,
    QueryUserFeedbackList,
    QueryUserSub,
    QueryUserUsage,
    RefreshSettingData,
    SaveSettingData,
    SolveFeedback,
    UpdateFeedback,
    UpdateSettingData,
    UpdateSettingDataAll
} from '../../request/system';
export default {
    namespace: true,
    state: {
        serveDate: null
    },

    mutations: {
        SET_SERVE_DATE(state, serveDate) {
            state.serveDate = serveDate;
        }
    },
    actions: {
        QUERY_USAGE: async ({ commit }, payload) => {
            let res = await QueryUsage(payload);
            return res;
        },
        QUERY_USER_USAGE: async ({ commit }, payload) => {
            let res = await QueryUserUsage(payload);
            return res;
        },
        QUERY_USAGE_SUB: async ({ commit }, payload) => {
            let res = await QueryUserSub(payload);
            return res;
        },
        QUERY_FEEDBACK: async ({}, payload) => {
            let res = await QueryFeedback(payload);
            return res;
        },

        ADD_FEEDBACK: async ({}, payload) => {
            let res = await AddFeedback(payload);
            return res;
        },

        UPDATE_FEEDBACK: async ({}, payload) => {
            let res = await UpdateFeedback(payload);
            return res;
        },

        SOLVE_FEEDBACK: async ({}, payload) => {
            let res = await SolveFeedback(payload);
            return res;
        },
        QUERY_FEEDBACK_INFO: async ({}, payload) => {
            let res = await QueryFeedbackInfo(payload);
            return res;
        },
        QUERY_USER_FEEDBACK_LIST: async ({}, payload) => {
            let res = await QueryUserFeedbackList(payload);
            return res;
        },

        QUERY_COMPANY_CODE: async ({}, payload) => {
            let res = await QueryCompanyCode(payload);
            return res;
        },
        QUERY_SERVE_DATE: async ({ commit }, payload) => {
            let res = await QueryServeDate(payload);
            if (res?.code == 200) {
                commit('SET_SERVE_DATE', res.data);
            } else {
                commit('SET_SERVE_DATE', moment().format('YYYY-MM-DD'));
            }
            return res;
        },

        QUERY_QUICK_MENU: async ({}, payload) => {
            let res = await QueryQuickMenu(payload);
            return res;
        },

        QUERY_TANENT: async ({}, payload) => {
            let res = await QueryTanent(payload);
            return res;
        },

        QUERY_SETTING_DATA: async ({}, payload) => {
            let res = await QuerySettingData(payload);
            return res;
        },
        SAVE_SETTING_DATA: async ({}, payload) => {
            let res = await SaveSettingData(payload);
            return res;
        },
        UPDATE_SETTING_DATA: async ({}, payload) => {
            let res = await UpdateSettingData(payload);
            return res;
        },
        UPDATE_SETTING_DATA_ALL: async ({}, payload) => {
            let res = await UpdateSettingDataAll(payload);
            return res;
        },
        DELETE_SETTING_DATA: async ({}, payload) => {
            let res = await DeleteSettingData(payload);
            return res;
        },
        REFRESH_SETTING_DATA: async ({}, payload) => {
            let res = await RefreshSettingData(payload);
            return res;
        }
    }
};
